import React from 'react';

import { Box } from '@mui/system';
import { Grid, Typography } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

import { pharmacyBillingSelector } from '@pharmaplan/common';

import { useAppSelector } from '../../../hooks/useAppSelector';
import strings from '../../../localization';

import { planComparison, TableSections } from './helper';
import styles from './styles';

const ComparePlansTable = () => {
  const billing = useAppSelector(pharmacyBillingSelector);
  const { unlimitedFees, basicFees } = billing ?? {};

  return (
    <Box sx={styles.container}>
      {planComparison(basicFees, unlimitedFees).map((item) => {
        const { key, rows } = item;
        const isHeader = key === TableSections.header;

        return (
          <Grid sx={styles.rowContainer} key={key} container>
            {isHeader && (
              <>
                <Grid xs={4} item />
                <Grid xs={4} item />
                <Grid sx={styles.recommendedContainer} xs={4} item>
                  <StarIcon sx={styles.star} />
                  <Typography sx={styles.recommendedLabel}>
                    {strings.recommended}
                  </Typography>
                </Grid>
              </>
            )}
            {rows.map((row, index) => {
              const { key: rowKey, label } = row;
              const isFirstItemRow = !isHeader && index === 0;

              return (
                <Grid
                  key={rowKey}
                  xs={4}
                  sx={[styles.rowItem, isHeader ? styles.headerContainer : {}]}
                  item
                >
                  <Typography
                    sx={[
                      styles.rowItemLabel,
                      isHeader ? styles.headerLabel : {},
                      isFirstItemRow && styles.firstItem,
                    ]}
                  >
                    {label}
                  </Typography>
                </Grid>
              );
            })}
          </Grid>
        );
      })}
    </Box>
  );
};
export default ComparePlansTable;
